import { ref } from '@vue/composition-api'
import moment from 'moment'
import 'moment-timezone'

const timeZone = 'Asia/Riyadh';

const start_time = {
  hour: 0,
  minute: 0,
  second: 0,
}

const end_time = {
  hour: 23,
  minute: 59,
  second: 59,
}

const start_today = moment().tz(timeZone).set(start_time).format('YYYY-MM-DD HH:mm:ss');
const end_today = moment().tz(timeZone).set(end_time).format('YYYY-MM-DD HH:mm:ss');
const rangeDate = ref(`${start_today} to ${end_today}`)
const from = ref(start_today)
const to = ref(end_today)

const conf = {
  mode:'range',
  enableTime: true,
  enableSeconds:true,
  time_24hr: true,
  defaultHour: 0,
  dateFormat: 'Y-m-d H:i:S',
  defaultDate: [
    start_today,
    end_today,
  ],
  onClose: function (data, dateStr) {
    const date = dateStr.split(' to ')
    from.value = date[0]
    to.value = date[1]
  },
  onChange: function(rawdate, altdate, FPOBJ) {
    // FPOBJ.close(); // Close datepicker on date select
    // FPOBJ._input.blur(); // Blur input field on date select
  }
}


export {
  rangeDate,
  conf,
  from,
  to
}